import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faXing,
} from "@fortawesome/free-brands-svg-icons";
import {
  faAward,
  faBars,
  faBuilding,
  faCar,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faChartLine,
  faClock,
  faDolly,
  faEnvelope,
  faEuroSign,
  faFileContract,
  faGraduationCap,
  faHouse,
  faHouseChimney,
  faLocationDot,
  faMarker,
  faNetworkWired,
  faPaperPlane,
  faParking,
  faPeopleGroup,
  faPhone,
  faStar,
  faSubway,
  faTree,
  faUserTie,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { SectionNavigationComponent } from "./shared/components/section-navigation/section-navigation.component";

@Component({
  imports: [CommonModule, RouterOutlet, StoreDevtoolsModule, SectionNavigationComponent],
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "remax";
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faXing,
      faInstagram,
      faFacebook,
      faEnvelope,
      faLinkedin,
      faStar,
      faAward,
      faDolly,
      faPeopleGroup,
      faUserTie,
      faHouse,
      faNetworkWired,
      faFileContract,
      faGraduationCap,
      faChartLine,
      faPaperPlane,
      faEuroSign,
      faBuilding,
      faPhone,
      faBars,
      faXmark,
      faCaretUp,
      faCaretLeft,
      faCaretDown,
      faCaretRight,
      faHouseChimney,
      faLocationDot,
      faClock,
      faMarker,
      faCar,
      faSubway,
      faParking,
      faTree
    );
  }
}
